// extracted by mini-css-extract-plugin
export default {"container":"signInButton_container__fOwYD","image-text-container":"signInButton_image-text-container__K7Xhz","icon":"signInButton_icon__jcFdU","text":"signInButton_text__wmd-G"};